export const FieldArray = {
  baseStyle: {
    marginTop: '40px',
  },
};
